export default {
      id: "ag-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#ag",
      toString: function () {
        return this.url;
      }
    }